import { NavLink } from "react-router";

export interface LinkButtonProps {
  to: string;
  children: React.ReactNode;
}

export default function LinkButton({ to, children }: LinkButtonProps) {
  return (
    <NavLink
      to={to}
      className="border-soluud-primary text-soluud-primary hover:bg-soluud-primary-light active:bg-soluud-primary-light focus-visible:ring-soluud-primary me-2 mb-2 inline-flex items-center rounded-lg border bg-transparent px-5 py-2.5 text-sm font-medium transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
    >
      {children}
    </NavLink>
  );
}
